/**
 * Third-party editor panels. Companion extensions add their own tab to the
 * live editor (settings persist in the theme document's `ext` bucket, so they
 * ride the same draft → preview → publish cycle as everything else).
 *
 * Two registration paths, both order-proof:
 *  - `app.bespoke.registerPanel(def)` once Bespoke's initializer has run;
 *  - push onto the global `window.BespokePanelQueue` at any time (even before
 *    Bespoke's chunk loads) — the queue is drained every time the editor
 *    renders its tab strip, so extension load order never matters.
 */

const registered = [];
export function registerBespokePanel(def) {
  if (!def || !def.id || !def.panel) return;
  if (registered.some(d => d.id === def.id)) return;
  registered.push(def);
}

/** All third-party panels, draining any queue entries pushed before/after boot. */
export function extraPanels() {
  const queue = window.BespokePanelQueue;
  if (Array.isArray(queue) && queue.length) {
    queue.splice(0).forEach(registerBespokePanel);
  }
  return registered;
}